import React from 'react';
import Row from '../../Row';
import Col from '../../Col';
import { downloadDocument } from 'src/helpers/DownloadDoc';
import {
  getURLExtension,
  getFileTypeIcon,
} from 'src/helpers/validationHelper';
import './download-attachment.scss';

const DownloadAttachment = ({ fileURL, fileName, align }) => {
  const downloadAttachment = () => {
    downloadDocument(fileURL);
  };

  const fileExtension = getURLExtension(fileURL);
  const fileIcon = getFileTypeIcon(fileExtension);

  return (
    <Row>
      <Col md={12} xs={12}>
        <div
          className={`download-attachment ${
            align === 'right' ? 'align-right' : 'align-left'
          }`}
        >
          <div className="attachment-bubble">
            <div className="attachment-chip">
              <img src={`/assets/${fileIcon}`} alt="" />{' '}
              <div className="file-name">{fileName}</div>
            </div>
            <hr className="attachment-divider" />
            <div className="download-link" onClick={downloadAttachment}>
              {' '}
              <a> Download </a>{' '}
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default DownloadAttachment;